export default {
	name: 'modal',
	inject: ['$validator'],
	props: {
		show: {
			type: Boolean,
			default: false
		},
		modalTitle: {
			type: String,
			default: ''
		},
		dialogSize: {
			type: String,
			default: null
		},
		disableClickOut: {
			type: Boolean,
			default: false
		},
		fields: {
			default: ""
		},
		closeText: {
			type: String,
			default: 'Close'
		}
	},
	computed: {
		openStyles() {
			return this.show ? { 'display': 'block' } : {};
		},
		modalDialogSize() {
			return this.dialogSize ? 'modal-'+this.dialogSize : '';
		}
	},
	methods: {
		close() {
			this.$emit('close');
		}
	},
	mounted() {
		document.addEventListener( 'keydown', e => {
			if(this.show && e.keyCode === 27) {
				this.close();
			}
		});
	}
}
